export const PINCODES_RESET_STATE = 'PINCODES_RESET_STATE';
export const PINCODES_CURRENT_ITEM = 'PINCODES_CURRENT_ITEM';

export const PINCODES_REQUEST_LOADING = 'PINCODES_REQUEST_LOADING';
export const PINCODES_REQUEST_SUCCESS = 'PINCODES_REQUEST_SUCCESS';
export const PINCODES_REQUEST_FAILED = 'PINCODES_REQUEST_FAILED';

export const PINCODES_CURRENT_ACTION = 'PINCODES_CURRENT_ACTION';
export const PINCODES_RESET_ACTION = 'PINCODES_RESET_ACTION';